import { Mail, Phone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { TRIAL } from "../../constants/testIds";

// UX-TRIAL §4 "the exact block modal pattern — reuse everywhere a cap is hit": calm,
// non-punitive, never a raw error. Mounted once in AppShell and driven globally by the
// `fitfrik:trial-cap-exceeded` window event (api.js interceptor) so every existing 403
// TRIAL_CAP_EXCEEDED response — members/branches/export/migration/etc — surfaces through this
// SAME component with zero per-screen wiring, mirroring the pre-existing read-only-lapse
// pattern. Also reused directly (not via the event) by the trial-status badge's own "Upgrade"
// click.
// Kairoo contact info below is a DOCUMENTED MOCKED placeholder — no real Kairoo Technologies
// sales line/inbox exists in this environment, same convention as every other seeded
// contact/email elsewhere in this build (e.g. seed_demo_gym.py's "hello@fitfrikdemo.example").
// Swap for the real number/inbox before any real launch.
const KAIROO_PHONE = "+91 98765 43210";
const KAIROO_EMAIL = "hello@kairoo.tech";

export function TrialBlockModal({ open, onOpenChange, message }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-modal sm:rounded-[16px] max-w-md" data-testid={TRIAL.blockModal}>
        <DialogHeader>
          <DialogTitle style={{ color: "var(--scarlet-text)" }}>This feature is part of the full FitFrikArena experience.</DialogTitle>
          <DialogDescription>
            {message || "This isn't available in your 14-day trial."} To unlock this and onboard your gym fully, contact Kairoo Technologies.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2.5 text-sm py-1">
          <a href={`tel:${KAIROO_PHONE.replace(/\s/g, "")}`} className="flex items-center gap-2 font-medium hover:opacity-80 transition-opacity" style={{ color: "var(--scarlet-text)" }}>
            <Phone size={15} /> {KAIROO_PHONE}
          </a>
          <a href={`mailto:${KAIROO_EMAIL}`} className="flex items-center gap-2 font-medium hover:opacity-80 transition-opacity" style={{ color: "var(--scarlet-text)" }}>
            <Mail size={15} /> {KAIROO_EMAIL}
          </a>
        </div>
        <DialogFooter className="flex-row justify-between sm:justify-between gap-2">
          <Button
            data-testid={TRIAL.blockModalContinue}
            type="button"
            variant="ghost"
            onClick={() => onOpenChange(false)}
          >
            Continue exploring the trial
          </Button>
          <Button data-testid={TRIAL.blockModalContact} asChild className="text-white" style={{ background: "var(--scarlet-accent)" }}>
            <a href={`tel:${KAIROO_PHONE.replace(/\s/g, "")}`}>Contact Kairoo</a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
